import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Download } from "lucide-react";
import OwlLogo from "./OwlLogo";

const NAV_LINKS = [
  { label: "L'app", hash: "#app" },
  { label: "Niveaux", hash: "#niveaux" },
  { label: "Parents", hash: "#parents" },
  { label: "Support", path: "/support" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToHash = (e, link) => {
    e.preventDefault();
    setOpen(false);
    if (link.hash) {
      const el = document.querySelector(link.hash);
      if (el) {
        if (window.__lenis) window.__lenis.scrollTo(link.hash, { offset: -70 });
        else el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate(`/${link.hash}`);
      }
    } else {
      navigate(link.path);
    }
  };

  if (location.pathname === "/admin") return null;

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-paper/85 backdrop-blur-md border-b border-ink/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="navbar-logo-link" onClick={() => setOpen(false)}>
          <OwlLogo className="w-9 h-9" />
          <span className="font-serif font-bold text-lg leading-none">
            Chouette <span className="italic text-coral">Apprentissage</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.hash || link.path}
              onClick={(e) => goToHash(e, link)}
              className="text-sm font-semibold text-ink/70 hover:text-ink transition-colors"
              data-testid={`navbar-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#telecharger"
            onClick={(e) => goToHash(e, { hash: "#telecharger" })}
            className="inline-flex items-center gap-2 rounded-full bg-ink text-paper px-5 py-2.5 text-sm font-bold transition-all hover:bg-inksoft hover:-translate-y-0.5"
            data-testid="navbar-download-cta"
          >
            <Download className="w-4 h-4" />
            Télécharger
          </a>
        </nav>

        <button
          className="md:hidden p-2 rounded-lg border border-ink/10 bg-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-ink/5 bg-paper px-6 py-4 space-y-3" data-testid="navbar-mobile-menu">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.hash || link.path}
              onClick={(e) => goToHash(e, link)}
              className="block text-base font-semibold py-1.5"
              data-testid={`navbar-mobile-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#telecharger"
            onClick={(e) => goToHash(e, { hash: "#telecharger" })}
            className="block text-center rounded-full bg-ink text-paper px-5 py-3 text-sm font-bold"
            data-testid="navbar-mobile-download-cta"
          >
            Télécharger l'app
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;